export default {
    data: function() {
        return {
            mapConfig: {
                mapTypeId: 'roadmap',
                scrollwheel: false,
                mapTypeControl: false
            },
            mapTools: [
                { name: 'zoom', css: 'right: 15px; bottom: 90px' },
                { name: 'street', css: 'right: 15px; bottom: 180px' },
                { name: 'maptype', css: 'left: 0px; top: 0px' }
            ],
            mobileMapTools: [
                { name: 'zoom', css: 'right: 15px; bottom: 90px' },
                { name: 'street', css: 'right: 15px; bottom: 180px' },
                { name: 'maptype', css: 'left: 20px; top: 20px' }
            ],
            markerData: {
                location: {
                    address: this.address
                }
            }
        };
    },
    created() {
        //  Define map module loading 
        this.psMap = new Promise(resolve => {
            this.psResolve = resolve;
        });
    },
    computed: {
        isMobile() {
            return this.platform.isMobile;
        },
        showTools() {
            return this.isMobile ? this.mobileMapTools : this.mapTools;
        },
        center() {
            var latlng = (this.centerPoint || '').split(',');
            if (latlng.length === 2) {
                return {
                    lat: latlng[0],
                    lng: latlng[1]
                };
            } else {
                return null;
            }
        }
    },
    watch: {
        center(a) {
            a && this.updateLocationMarker();
        },
        address() {
            this.updateLocationMarker();
        }
    },
    methods: {
        mapLoad(siteMap, map, maps) {
            this.siteMap = siteMap;
            this.map = map;
            this.maps = maps;
            this.psResolve();
            this.updateLocationMarker();
        },
        updateLocationMarker() {
            this.psMap.then(() => {
                this.markerData = Object.assign({}, this.markerData, {
                    location: this.address
                        ? {
                            address: this.address,
                            ...(this.center || this.siteMap.config.center)
                        }
                        : null
                });
            });
        }
    }
};
